/*
* Project: LegalPlace assistant
* File: src/components/buy/options.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  ckSetCall,
  ckSetSending,
  ckUpdateLettersNbr,
  ckUpdateName,
  ckUpdateAddress,
  ckUpdateCity,
  ckUpdateZip,
} from '../../redux/actions/checkout_operations';
import {
  lpPattern,
  P_ADD_CALL, P_REMOVE_CALL, P_ADD_LETTER, P_REMOVE_LETTER, P_CHANGE_LETTER, P_UPDATE_ADDRESS,
} from '../../tracking/pattern_detector';
import { _lp } from '../../logic/wording';

class _OptionsSelection extends Component {
  render() {
    return (
      <section className="page-section hidden-xs" id="pack-options">
        <h3 className="section-title">Options Complémentaires</h3>

        <div className="media pack-option">
          <div className="media-left">
            <img src="/wizard/img/icn-user.svg" />
          </div>
          <div className="media-body">
            <h5 className="media-heading">{_lp('20 minutes d\'appel avec un avocat expérimenté')}</h5>
          </div>
          <div className="media-right">
            {!this.props.call_state ? <span className="lp-cart-price">29.90 €</span>
              : (
                <span className="po-added">
                  <i className="icn-checkmark" />
                </span>
              )}
          </div>
          <div className="media-x-right">
            {!this.props.call_state ? (
              <a className="btn po-btn-add" onClick={this.props.addCall}>
                {_lp('Ajouter')}
              </a>
            )
              : (
                <a className="btn po-btn-delete" onClick={this.props.removeCall}>
                  {_lp('Enlever')}
                </a>
              )}
          </div>
        </div>

        <div className="media pack-option">
          <div className="media-left">
            <img src="/wizard/img/icn-letter.svg" />
          </div>
          <div className="media-body">
            <h5 className="media-heading">{_lp('Recevoir mon document par courrier')}</h5>
          </div>
          <div className="media-right">
            {!this.props.letter_state ? <span className="lp-cart-price">3.90 €</span>
              : (
                <span className="po-added">
                  <i className="icn-checkmark" />
                </span>
              )}
          </div>
          <div className="media-x-right">
            {!this.props.letter_state ? (
              <a className="btn po-btn-add" onClick={this.props.addLetter}>
                {_lp('Ajouter')}
              </a>
            )
              : (
                <a className="btn po-btn-delete" onClick={this.props.removeLetter}>
                  {_lp('Enlever')}
                </a>
              )}
          </div>
          <div className={`form-inline pack-qte${(this.props.letter_state) ? '' : ' hidden'}`}>
            <div className="form-group">
              <label htmlFor="qte">{_lp("Nombre d'exemplaires")}</label>
              <input type="number" className="form-control" id="qte" min="1" value={this.props.letter_nbr} onChange={evt => this.props.updateNumber(evt.target.value)} />
            </div>
          </div>
          <div className={`pack-address-receive${(this.props.letter_state) ? '' : ' hidden'}`}>
            <div className="row">
              <div className="form-group col-sm-6">
                <label htmlFor="d1">{_lp('Nom et prénoms ou nom de la société')}</label>
                <input type="text" className="form-control" id="d1" value={this.props.letter_name} onChange={val => this.props.updateName(val.target.value)} />
              </div>
              <div className="form-group col-sm-6">
                <label htmlFor="d1">{_lp('Adresse complète')}</label>
                <input type="text" className="form-control" id="d1" value={this.props.letter_address} onChange={e => this.props.updateAddress(e.target.value)} />
              </div>
              <div className="form-group col-sm-6">
                <label htmlFor="d1">{_lp('Ville')}</label>
                <input type="text" className="form-control" id="d1" value={this.props.letter_city} onChange={e => this.props.updateCity(e.target.value)} />
              </div>
              <div className="form-group col-sm-6">
                <label htmlFor="d1">{_lp('Code postal')}</label>
                <input type="text" className="form-control" id="d1" value={this.props.letter_zip} onChange={e => this.props.updateZip(e.target.value)} />
              </div>
            </div>

          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => ({
  call_state: state.checkout_operations.has_call,
  letter_state: state.checkout_operations.has_letter,
  letter_nbr: state.checkout_operations.letter.number,
  letter_name: state.checkout_operations.letter.name,
  letter_address: state.checkout_operations.letter.address,
  letter_city: state.checkout_operations.letter.city,
  letter_zip: state.checkout_operations.letter.zip,
});

const mapDispatchToProps = dispatch => ({
  addCall: () => {
    dispatch(ckSetCall(true));
    lpPattern.trackInPayment(P_ADD_CALL);
  },
  removeCall: () => {
    dispatch(ckSetCall(false));
    lpPattern.trackInPayment(P_REMOVE_CALL);
  },
  addLetter: () => {
    dispatch(ckSetSending(true));
    lpPattern.trackInPayment(P_ADD_LETTER);
  },
  removeLetter: () => {
    dispatch(ckSetSending(false));
    lpPattern.trackInPayment(P_REMOVE_LETTER);
  },
  updateNumber: (val) => {
    dispatch(ckUpdateLettersNbr(val));
    lpPattern.trackInPayment(P_CHANGE_LETTER);
  },
  updateName: (val) => {
    dispatch(ckUpdateName(val));
  },
  updateAddress: (val) => {
    dispatch(ckUpdateAddress(val));
    lpPattern.trackInPayment(P_UPDATE_ADDRESS);
  },
  updateCity: (val) => {
    dispatch(ckUpdateCity(val));
  },
  updateZip: (val) => {
    dispatch(ckUpdateZip(val));
  },
});

const OptionsSelection = connect(mapStateToProps, mapDispatchToProps)(_OptionsSelection);

export default OptionsSelection;



// WEBPACK FOOTER //
// ./src/components/buy/options.js